import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgShowFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 5c-3.912 0-7.143 2.025-9.693 6.074a1.997 1.997 0 0 0 .026 2.168C4.878 17.081 8.1 19 12 19c3.906 0 7.133-1.972 9.68-5.916a1.998 1.998 0 0 0 0-2.168C19.133 6.972 15.906 5 12 5Zm3.005 7c0 1.657-1.345 3-3.005 3a3.002 3.002 0 0 1-3.004-3c0-1.657 1.345-3 3.004-3a3.002 3.002 0 0 1 3.005 3Z", fill: color }));
};
export default factorySvgIcon(SvgShowFilled);
//# sourceMappingURL=SvgShowFilled.js.map